import React, { useState, useEffect } from "react";
// import discord from "../images/new/discord.svg";
// import twitter from "../images/new/twitter.svg";
// import opensea from "../images/new/opensea.svg";
import color_logo from "../images/new/color_logo.svg";
import white_logo from "../images/new/white_logo.svg";
import close from "../images/close.svg";
import metaSocial from "../images/menu-social.png";
import linkedin from "../images/new/footer/linkedin.png";
import facebook from "../images/new/footer/facebook.png";
import discord from "../images/new/footer/discord.png";
import instagram from "../images/new/footer/instagram.png";
import twitter from "../images/new/footer/twitter.png";
import curveText from "../images/new/footer/curvetext.svg";
import { Link } from "react-router-dom";

function Header2() {
  const [
    isScrollValueMoreThanHeaderHeight,
    setIsScrollValueMoreThanHeaderHeight,
  ] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleScroll = () => {
    setIsScrollValueMoreThanHeaderHeight(window.scrollY > 5);
  };
  window.addEventListener("scroll", handleScroll);

  const menuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header
      className={`nav-wrapper ${
        isScrollValueMoreThanHeaderHeight ? "scrolledHeader" : ""
      }`}
    >
      <nav>
        <ul>
          <li>
            <button className="headerButton secondary" onClick={menuToggle}>
              Menu
            </button>
          </li>
          <li className="logo">
            <Link to="/" className="scroll">
              {isScrollValueMoreThanHeaderHeight ? (
                <img src={color_logo} className="color-logo" alt="logo" />
              ) : (
                <img src={white_logo} className="white-logo" alt="logo" />
              )}
            </Link>
          </li>
          <li>
            <Link to={"/marketplace"} className="headerButton primary" target="_blank">
              Marketplace
            </Link>
          </li>
        </ul>
      </nav>
      <div className={`fullMenu ${isMenuOpen ? "show" : ""}`}>
        <button className="closeFullMenu" onClick={menuToggle}>
          <img src={close} alt="Close Icon" />
        </button>
        <div className="fullMenuContent">
          <ul className="fullMenuItems">
            <li>
              <Link to={"/"} className="fullMenuItem" onClick={menuToggle}>
                Home
              </Link>
            </li>
            <li>
              <Link
                to={"/artistsproject"}
                className="fullMenuItem"
                onClick={menuToggle}
              >
                Artists & Projects
              </Link>
            </li>
            <li>
              <Link to={"/pets"} className="fullMenuItem" onClick={menuToggle}>
                Pets
              </Link>
            </li>
            <li>
            <Link to={"/twitter"} className="fullMenuItem" onClick={menuToggle} target="_blank">
            TWITTER COMMUNITY
              </Link>
            </li> 
            <li>
              <Link to={"/team"} className="fullMenuItem" onClick={menuToggle}>
                Team
              </Link>
            </li>
            <li>
              <Link to={"/meme-creator"} className="fullMenuItem" onClick={menuToggle}>
                Create Meme
              </Link>
            </li>
            <li>
              <Link to={"/auras"} className="fullMenuItem" onClick={menuToggle}>
                Auras
              </Link>
            </li> 
            <li>
            <Link to={"/IPrights"} className="fullMenuItem" onClick={menuToggle}>
            Ip Rights
              </Link>
            </li>

            {/*<li>
              <Link to={"/"} className="fullMenuItem" onClick={menuToggle}>
                Collabs
              </Link>
            </li>
            <li>
              <Link to={"/"} className="fullMenuItem" onClick={menuToggle}>
                Customize Art
              </Link>
            </li>
            <li>
              <Link to={"/"} className="headerButton primary">
                Docs and IP Rights
              </Link>
            </li> */}
          </ul>
          <div className="fullMenuSocial">
            <img src={curveText} alt="" className="curveText" />
            <div className="metaImage">
              <a
                href="https://www.linkedin.com/company/the-heal-app/"
                className="socialIcon socialIcon1"
                target="_blank"
                rel="noreferrer"
              >
                <img src={linkedin} alt="LinkedIn" />
              </a>
              {/* <Link href="/"} className="socialIcon socialIcon2" target="_blank">
                <img src={facebook} alt="Facebook" />
              </Link> */}
              <a
                href="https://discord.com/invite/tsvjugjFZx"
                className="socialIcon socialIcon2"
                target="_blank"
                rel="noreferrer"
              >
                <img src={discord} alt="discord" />
              </a>
              <a
                href="https://www.instagram.com/healingnfts/"
                className="socialIcon socialIcon4"
                target="_blank"
                rel="noreferrer"
              >
                <img src={instagram} alt="Instagram" />
              </a>
              <a
                href="https://twitter.com/HealingNFTs/"
                className="socialIcon socialIcon5"
                target="_blank"
                rel="noreferrer"
              >
                <img src={twitter} alt="Twitter" />
              </a>
              <img src={metaSocial} alt="" />
            </div>
          </div>
          <div className="mobileMenuSocial">
            <ul>
              <li>
                <a
                  href="https://www.linkedin.com/company/the-heal-app/"
                  className="mobileSocialIcon"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={linkedin} alt="LinkedIn" />
                </a>
              </li>
              {/* <li>
                <Link to={"/"} className="mobileSocialIcon" target="_blank">
                  <img src={facebook} alt="Facebook" />
                </Link>
              </li> */}
              <li>
                <a
                  href="https://discord.com/invite/tsvjugjFZx"
                  className="mobileSocialIcon"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={discord} alt="Discord" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/healingnfts/"
                  className="mobileSocialIcon"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={instagram} alt="Instagram" />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/HealingNFTs"
                  className="mobileSocialIcon"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={twitter} alt="Twitter" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header2;
